export default __webpack_public_path__ + "static/media/arrow.c3a0ff40.png";